import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import styles from './Topbar.module.css';

/**
 * Topbar — titre + sélecteur de mois + CTA principal + LanguageSwitcher.
 *
 * Props :
 *  - greeting    : "Bonjour Florian 🌿"
 *  - subtitle    : "Rapport d'avril 2026 · mis à jour il y a 1h"
 *  - months      : [{ value, label }]
 *  - selectedMonth · onMonthChange
 *  - ctaLabel · onCtaClick
 *
 * Le LanguageSwitcher (mode compact) est rendu côté droit, à côté du CTA,
 * pour permettre au restaurateur de changer de langue sans quitter son dashboard.
 */
export default function Topbar({
  greeting,
  subtitle,
  months,
  selectedMonth,
  onMonthChange,
  hideMonth = false,
  ctaLabel,
  onCtaClick,
  onMenuClick,
}) {
  const { t } = useTranslation('dashboard');

  // Fallbacks i18n-isés. Les anciens defaults FR hardcodés sont remplacés par
  // les traductions du namespace dashboard. Si le caller ne passe rien, on
  // affiche un greeting/subtitle générique multilingue.
  const safeGreeting = greeting || t('topbar.greeting_hello');
  const safeSubtitle = subtitle || t('topbar.fallback_subtitle');
  const safeCtaLabel = ctaLabel || t('topbar.cta_collect');

  return (
    <header className={styles.topbar}>
      <div className={styles.left}>
        <button
          type="button"
          className={styles.hamburger}
          onClick={onMenuClick}
          aria-label={t('topbar.menu_label')}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
            <line x1="3" y1="6"  x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        <div>
          <h1 id="user-prenom">{safeGreeting}</h1>
          <p>{safeSubtitle}</p>
        </div>
      </div>
      <div className={styles.actions}>
        {!hideMonth && months && (
          <select
            id="month-selector"
            className={styles.monthSelect}
            value={selectedMonth}
            onChange={(e) => onMonthChange && onMonthChange(e.target.value)}
          >
            {months.map((m) => (
              <option key={m.value} value={m.value}>{m.label}</option>
            ))}
          </select>
        )}
        <LanguageSwitcher compact />
        <button type="button" className={styles.btnPrimary} onClick={onCtaClick}>
          {safeCtaLabel}
        </button>
      </div>
    </header>
  );
}
